import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  CircularProgress,
  Dialog,
  DialogContent,
  Box
} from '@mui/material';

export const LoadingModal = ({ isOpen, label }) => (
  <Dialog open={isOpen} maxWidth="xs" fullWidth>
    <DialogContent>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="20px"
        minHeight="200px"
      >
        <CircularProgress color="button" />
        <Typography variant="body2">{label}</Typography>
      </Box>
    </DialogContent>
  </Dialog>
);

LoadingModal.propTypes = {
  isOpen: PropTypes.bool,
  label: PropTypes.string
};

LoadingModal.defaultProps = {
  isOpen: false,
  label: ''
};
